<template>
    <Modal :close_button="true" :size="'modal-md'" mid="confirm-delete-category">
        <template v-slot:header>{{$t('management_console.category_modal.delete_title')}}</template>
        <template v-slot:body>
            <p v-if="category">{{$t('management_console.category_modal.category')}}: <strong>{{category.name}}</strong></p>
            <p>{{$t('management_console.category_modal.delete_description')}}</p>
            <p>{{$t('management_console.category_modal.unassign_description')}}</p>
        </template>
        <template v-slot:footer>
            <button type="button" class="btn btn-danger bg-gradient px-4" @click="submit()">{{$t('management_console.common.delete')}}</button>
            <button type="button" class="btn px-4" @click="cancel()">{{$t('controls.cancel')}}</button>
        </template>
    </Modal>
</template>

<script>
import InventoryCategoryStore from '@/common/store/inventory_category.js'

export default {
    props: {
        category: {
            type: Object,
            default: () => {}
        }
    },
    data: function () {
        return {
            agree: false
        }
    },
    methods: {
        cancel: async function () {
            this.$bus.$emit('Modal/hide/confirm-delete-category')
        },
        submit: async function () {
            const response = await InventoryCategoryStore.dispatch('DELETE_CATEGORY', { category_id: this.category.id })
            if (response.status === 0) {
                this.agree = false
                this.$bus.$emit('Notification/show', { title: this.$t('notifications.operation_success'), msg: this.$t('management_console.category_modal.deleted'), level: 'success' })
                this.$bus.$emit('Modal/hide/confirm-delete-category')
            } else {
                this.$bus.$emit('Notification/show', { title: this.$t('notifications.something_went_wrong'), msg: this.$t('notifications.please_retry_the_operation_or_refresh'), level: 'danger' })
            }
        }
    }
}
</script>
